export const DEFAULT_VIDEO_NAME = 'Untitled_video';
export const DEFAULT_PROJECT_NAME = 'Add title';
